import { SPHUser, SPHUserRole } from './../../shared/model/sph-user.model';
import { Component, OnInit, Input } from '@angular/core';
import { SPHLoggedInUser, LicenseManagerService } from '../../shared/shared';
import { ViewController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'user-details',
    templateUrl: 'user-details.component.html'
})

export class UserDetailsComponent {
    private formGroup: FormGroup;

    private _loggedinUser: SPHLoggedInUser;
    @Input() set loggedinUser(loggedInUser: SPHLoggedInUser) {
        this._loggedinUser = loggedInUser;
    }
    get loggedinUser(): SPHLoggedInUser {
        return this._loggedinUser;
    }

    private _user: SPHUser;
    @Input() set user(user: SPHUser) {
        this._user = user;

        if (user !== undefined) {
            this.formGroup.patchValue({
                email: user.email,
                username: user.username,
                fullname: user.fullname,
                mobile: user.mobile,
                role: user.role
            });
        }

    }
    get user(): SPHUser {
        return this._user;
    }

    constructor(private viewController: ViewController, private formBuilder: FormBuilder, private navParams: NavParams, private licenseManager: LicenseManagerService, private toastController: ToastController) {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        const user = navParams.get('user');

        if (user !== undefined && user.id !== '-1') {

            this.formGroup = this.formBuilder.group({
                username: ['', Validators.required],
                email: ['', [ Validators.required, Validators.pattern(EMAIL_REGEXP) ] ],
                fullname: [''],
                mobile: [''],
                password: ['']
            }, {
                    // validator: CompanyDetailsComponent.matchPasswords
                });
        } else {
            this.formGroup = this.formBuilder.group({
                username: ['', Validators.required],
                email: ['', [ Validators.required, Validators.pattern(EMAIL_REGEXP) ]],
                fullname: [''],
                mobile: [''],
                password: ['', Validators.required]
            }, {
                    // validator: CompanyDetailsComponent.matchPasswords
                });
        }

        this.loggedinUser = navParams.get('loggedinUser');
        this.user = navParams.get('user');
    }

    public didTapAbort() {
        this.viewController.dismiss();
    }

    private didTapSaveUser() {
        const user = new SPHUser();

        user.username = this.formGroup.value['username'];
        user.email = this.formGroup.value['email'];
        user.fullname = this.formGroup.value['fullname'];
        user.role = SPHUserRole.SuperAdmin;
        user.mobile = this.formGroup.value['mobile'];

        if (this.formGroup.value['password'] !== '') {
            user.password = this.formGroup.value['password'];
        }

        user.id = this.user.id;

        if (+user.id !== -1) {
            this.licenseManager.patchUser(user, this.loggedinUser.jwt)
            .subscribe(() => {
                this.viewController.dismiss();
                const toast = this.toastController.create({message: 'Nutzer erfolgreich geändert', duration: 3000});
                toast.present();
            }, this.licenseManager.handleHttpError('Fehler beim Speichern des Nutzers'));
        } else {
            this.licenseManager.postUser(user, this.loggedinUser.jwt)
            .subscribe( () => {
                const toast = this.toastController.create({message: 'Nutzer erfolgreich angelegt.', duration: 3000});
                toast.present();
                this.viewController.dismiss();
            }, this.licenseManager.handleHttpError('Fehler beim Anlegen des Nutzers'));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/features/userManagement/userDetailsComponent/user-details.component.ts